import React from "react";
import StopChipList from "../StopChipList";
import StopProperties from "../StopProperties";
import RadioGroupComponent from "./RadioGroupComponent";
import DestinationRouteList from "./DestinationRouteList";
import { postData } from "../../../../../../api/componentAPIs";
import {
  MERGE_TYPES,
  getDestinationRouteList,
  getPreferredRouteNameListForDeliveryStops,
  getDefaultMergeDeliveryStopInfo,
  getListByKey,
  getCustomerAddressList,
  getCustomerInfoList,
  getCustomerFieldError,
  getUniqueLabelValue,
  getCustomersDeliveryWindowsDetail,
} from "../utills";
import MergeStopsActions from "./MergeStopsActions";
import { inject, observer } from "mobx-react";
import { withSnackbar } from "notistack";

@inject("IBPlanningStore")
@observer
class DeliveryStopMergeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mergeStopInProgress: false,
      mergeStopInfo: getDefaultMergeDeliveryStopInfo(),
      errorInfo: {},
      customers: [],
      deliveryWindowList: [],
      customerPreferredRouteNameList: [],
    };
  }

  componentDidMount() {
    this.initializeMergeStopDetails();
  }

  initializeMergeStopDetails = () => {
    const customerIds = [
      ...new Set(this.props.selectedStops.map((stop) => stop.originalCustomerCode)),
    ];
    this.destinationRouteList = getDestinationRouteList(
      this.props.selectedStops
    );
    this.getCustomerData(customerIds);
    const { selectedStops } = this.props;
    this.consigneeNameList = getListByKey(selectedStops, "consigneeName");
    this.addressList = getCustomerAddressList(selectedStops);
    this.customerInfoList = getCustomerInfoList(selectedStops);

    this.setState({
      mergeStopInfo: {
        mergedCustomerId:
          this.customerInfoList.length === 1
            ? this.customerInfoList[0].value.toString()
            : null,
        customerName:
          this.consigneeNameList.length === 1
            ? this.consigneeNameList[0].value.toString()
            : null,
        customerIdForAddress:
          this.addressList.length === 1
            ? this.addressList[0].value.toString()
            : null,
        customerPreferredRouteName: null,
        customerIdForDeliveryWindow: null,
        duplicateCustomerId: null,
        destinationRouteName: null,
      },
    });
  };

  getCustomerData = (customerCodes) => {
    this.props.fetchCustomerData(customerCodes).then((response) => {
      if (response && Math.trunc(response.status / 100) === 2) {
        this.setState(
          {
            customers: response?.data ?? [],
          },
          this.updateMergeStopList
        );
      }
    });
  };

  updateMergeStopList = () => {
    const customerPreferredRouteNameList =
      getPreferredRouteNameListForDeliveryStops(
        this.state.customers,
        this.props.selectedStops
      );
    const deliveryWindowList = this.getDeliveryWindowList();
    this.setState((prevState) => ({
      deliveryWindowList,
      customerPreferredRouteNameList,
      mergeStopInfo: {
        ...prevState.mergeStopInfo,
        customerIdForDeliveryWindow:
          deliveryWindowList.length === 1
            ? deliveryWindowList[0].value.toString()
            : null,
        customerPreferredRouteName:
          customerPreferredRouteNameList.length === 1
            ? customerPreferredRouteNameList[0].value.toString()
            : null,
      },
    }));
  };

  // Checks for errors for each field
  getFieldError = (field, value) => {
    const { customerPreferredRouteNameList, deliveryWindowList } = this.state;
    return getCustomerFieldError({
      field,
      value,
      customerPreferredRouteNameList,
      deliveryWindowList,
      destinationRouteList: this.destinationRouteList,
    });
  };

  getRequestData = (mergeStopInfo) => {
    const requestData = mergeStopInfo;
    requestData.terminalId = this.props.userData.userProfile.terminal.id;
    requestData.scenarioId = this.props.userData.userProfile.scenarioID;
    const duplicateCustomer =
      this.props.selectedStops.filter(
        (stop) => stop.consigneeId != Number(requestData.mergedCustomerId)
      ) || [];
    requestData.duplicateCustomerId = duplicateCustomer.map(
      (customer) => customer.consigneeId
    );
    if (requestData.destinationRouteName === null) {
      requestData.destinationRouteName = this.destinationRouteList[0].value;
    }
    return requestData;
  };

  mergeCustomers = () => {
    const errorInfo = this.getErrorInfo();
    const fieldError = Object.values(errorInfo).filter((value) => value).length;
    this.setState({ mergeStopInProgress: !fieldError, errorInfo });
    if (fieldError) {
      return;
    }
    const requestData = this.getRequestData(this.state.mergeStopInfo);
    postData("MergeCustomers", requestData).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          this.handleSuccess(requestData);
          return;
        }
        this.handleError(requestData);
      },
      (error) => {
        this.handleError(requestData);
      }
    );
  };

  handleSuccess = (requestData) => {
    if (this.props.mergeType === MERGE_TYPES.Customers) {
      this.props.onMergeCompleted();
    }
    this.props.glEventHub.emit("DispatchEvents", "RefreshIBStore", [
      false,
      this.props.IBPlanningStore.selectedRouteNameList,
    ]);
    this.setState({ mergeStopInProgress: false });
    this.props.enqueueSnackbar("Stops merged successfully.", {
      variant: "success",
    });
    this.props.trackMergeActions("DeliveryMergeSuccess", requestData);
    this.props.onClose();
  };

  handleError = (requestData) => {
    this.props.enqueueSnackbar(
      `An error occurred while merging stops. Please try again later.`,
      {
        variant: "error",
      }
    );
    this.props.trackMergeActions("DeliveryMergeFailure", requestData);
    this.setState({ mergeStopInProgress: false });
  };

  handleSelectUpdate = (name) => (event) => {
    const value = event.value;
    this.setState((state) => ({
      mergeStopInfo: {
        ...state.mergeStopInfo,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
    }));
  };

  handleUpdate = (name) => (event) => {
    const value = event.target.value;
    this.setState((state) => ({
      mergeStopInfo: {
        ...state.mergeStopInfo,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
    }));
  };

  getDeliveryWindowList = () => {
    return getUniqueLabelValue(
      this.props.selectedStops.map((stop) => {
        return getCustomersDeliveryWindowsDetail(this.state.customers, stop);
      })
    );
  };

  getErrorInfo = () => {
    const errorInfo = {};
    Object.keys(this.state.mergeStopInfo).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.mergeStopInfo[fieldName]
      );
    });
    return errorInfo;
  };

  render() {
    const { classes, selectedStops, mergeType } = this.props;
    const {
      errorInfo,
      mergeStopInfo,
      deliveryWindowList,
      customerPreferredRouteNameList,
    } = this.state;
    return (
      <div className={classes.mergeContainer}>
        <div className={`${classes.main} customScroll`}>
          <div className={classes.group}>
            <div>Selected Stops</div>
            <StopChipList customerStops={selectedStops} />
            {mergeType === MERGE_TYPES.Stops && (
              <StopProperties selectedStops={selectedStops} />
            )}
          </div>
          <RadioGroupComponent
            name="customerName"
            value={mergeStopInfo.customerName}
            options={this.consigneeNameList}
            onChange={this.handleUpdate("customerName")}
            label="Customer Name"
            errorInfo={errorInfo}
          />
          <RadioGroupComponent
            name="customerIdForAddress"
            value={mergeStopInfo.customerIdForAddress}
            options={this.addressList}
            onChange={this.handleUpdate("customerIdForAddress")}
            label="Address"
            errorInfo={errorInfo}
          />
          <RadioGroupComponent
            name="mergedCustomerId"
            value={mergeStopInfo.mergedCustomerId}
            options={this.customerInfoList}
            onChange={this.handleUpdate("mergedCustomerId")}
            label="Customer #"
            errorInfo={errorInfo}
          />
          {customerPreferredRouteNameList.length > 0 && (
            <RadioGroupComponent
              name="customerPreferredRouteName"
              value={mergeStopInfo.customerPreferredRouteName}
              options={customerPreferredRouteNameList}
              onChange={this.handleUpdate("customerPreferredRouteName")}
              label="Customer Preferred Route Name"
              errorInfo={errorInfo}
            />
          )}
          {this.destinationRouteList?.length > 1 && (
            <DestinationRouteList
              options={this.destinationRouteList}
              onChange={this.handleSelectUpdate("destinationRouteName")}
              value={mergeStopInfo.destinationRouteName}
              errorInfo={errorInfo}
              classes={classes}
            />
          )}
          {deliveryWindowList.length > 0 && (
            <RadioGroupComponent
              name="customerIdForDeliveryWindow"
              value={mergeStopInfo.customerIdForDeliveryWindow}
              options={deliveryWindowList}
              onChange={this.handleUpdate("customerIdForDeliveryWindow")}
              label="Delivery Window"
              errorInfo={errorInfo}
            />
          )}
        </div>
        <MergeStopsActions
          mergeStopInProgress={this.state.mergeStopInProgress}
          onClose={this.props.onClose}
          onMergeClick={this.mergeCustomers}
          classes={classes}
        />
      </div>
    );
  }
}

export default withSnackbar(DeliveryStopMergeForm);
